enum TicketStatus {
  Open = 'Open',
  InProgress = 'InProgress',
  Closed = 'Closed',
}

export default TicketStatus;
